import React, { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { referrals } from '@constants/referrals';
import useQuoter from '@hooks/usePageQuoter';
import useSteps from '@hooks/useSteps';
import Layout from '@layouts/FlowLayout';
import getAgent, { GetAgentResponseT } from '@services/getAgent';
import { useLeadStore } from '@stores';
import Quoter from '@templates/Quoter';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { query } = context;

  const agent = query.agente || query['ventaAsistida'];
  const assistedSale = !!query['ventaAsistida'];

  let agentData: GetAgentResponseT = null;

  if (agent) {
    try {
      agentData = await getAgent({ cipherAgent: agent });
    } catch (error) {
      console.error(error);
    }
  }

  const referral = referrals.includes(query.referral as string) ? query.referral : null;

  return {
    props: {
      agentData: agentData?.getAgent || null,
      referral,
      assistedSale,
    },
  };
};

const stepName = 'cotizador';

export function Cotizador({ agentData, referral, assistedSale }): ReactElement {
  const { t } = useTranslation();
  const { maxSteps: steps, count, currentStep } = useSteps({ currentStepName: stepName });
  const { setOriginReferrer, lead } = useLeadStore();
  const {
    handleBack,
    handleContinue,
    selectedPlan,
    setSelectedPlan,
    noInsuredMembers,
    setNoInsuredMembers,
    loading,
    preLoading,
    dataIsValid,
    isFlowLoading,
  } = useQuoter({ agent: agentData, assistedSale, referral });

  useEffect(() => {
    if (document.referrer && !lead?.originReferrer) {
      setOriginReferrer(document.referrer);
    }
  }, [setOriginReferrer, lead?.originReferrer]);

  return (
    <>
      <Layout
        id={stepName}
        dataTestid={stepName}
        stepFooterProps={{
          continueBtn: {
            onClick: () => handleContinue(),
            text: t('CONTINUE'),
            isLoading: loading,
            isDisabled: !dataIsValid,
          },
          backBtn: { onClick: () => handleBack(), text: t('BACK') },
          flow: {
            steps,
            currentStep,
            missingStepsText: t('flow.plural_steps_remaining', { count }),
            wasIncreased: false,
          },
        }}
      >
        <Quoter
          preLoading={preLoading || isFlowLoading}
          selectedPlan={Number(selectedPlan)}
          setSelectedPlan={setSelectedPlan}
          noInsuredMembers={noInsuredMembers}
          setNoInsuredMembers={setNoInsuredMembers}
        />
      </Layout>
    </>
  );
}

export default Cotizador;
